import { useEffect, useRef, useState } from 'react'

export const useCountUp = (target: number, duration = 700): number => {
    const [value, setValue] = useState(target)
    const fromRef = useRef(target)

    useEffect(() => {
        const from = fromRef.current

        if (from === target) return

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            fromRef.current = target
            setValue(target)

            return
        }

        let frame = 0
        const start = performance.now()

        const tick = (now: number): void => {
            const progress = Math.min(1, (now - start) / duration)
            const eased = 1 - Math.pow(1 - progress, 3)
            const current = Math.round(from + (target - from) * eased)

            fromRef.current = current
            setValue(current)

            if (progress < 1) frame = requestAnimationFrame(tick)
        }

        frame = requestAnimationFrame(tick)

        return () => cancelAnimationFrame(frame)
    }, [target, duration])

    return value
}
